import React, { useState, useMemo, memo } from 'react';
import MultiSelectSearch from '../../components/MultiSelectSearch/MultiSelectSearch';
import ProfessionalSearch from '../../components/ProfessionalSearch/ProfessionalSearch';
import { ENDPOINTS } from '../../constants';
import { GLOBAL_OVERVIEW_SHIFT_ROUTES, SHIFT_FEATURES } from '../../constants/ShiftStatus';

const GlobalOverviewFilters = ({
	activeOptions,
	selectedCaregiver,
	handleMultiSelectFiltersApply,
	removeSelectedCaregiver,
	handleCaregiverFilterSelection,
	globalScheduleType,
	areAllFacilitiesSelected,
	isHybridEnabled,
	isFlexEnabled,
	isOnDemandEnabled,
	isSplitShiftEnabled
}) => {
	const [isCaregiverSelectOpen, setIsCaregiverSelectOpen] = useState(false);

	const handleRemoveCaregiver = () => {
		setIsCaregiverSelectOpen(false);
		removeSelectedCaregiver();
	};

	const routeOptions = useMemo(() => {
		if (!isHybridEnabled) {
			return activeOptions.shiftRoutes.filter((sr) => sr.label !== GLOBAL_OVERVIEW_SHIFT_ROUTES.HYBRID.name);
		}
		return activeOptions.shiftRoutes;
	}, [activeOptions.shiftRoutes, isHybridEnabled]);

	const featureOptions = useMemo(() => {
		if (!isFlexEnabled || !isSplitShiftEnabled) {
			return activeOptions.features.filter((feature) => feature.label !== SHIFT_FEATURES.SPLIT_SHIFT);
		}
		return activeOptions.features;
	}, [activeOptions.features, isFlexEnabled, isSplitShiftEnabled]);

	const shouldShowUnitsFilter =
		(areAllFacilitiesSelected && activeOptions.units.length > 0) || !areAllFacilitiesSelected;
	const isUnitsFilterDisabled = !areAllFacilitiesSelected && activeOptions.units.length === 0;

	return (
		<div className="filters-container">
			<div className="inline-filters">
				<MultiSelectSearch
					showLongSelectionText
					className="select-filter-type-container"
					label="Shift type"
					options={activeOptions.resourceTypes}
					onApply={(options) => handleMultiSelectFiltersApply('resourceTypes', options)}
				/>
				<MultiSelectSearch
					showLongSelectionText
					className="select-filter-status-container"
					label="Status"
					options={activeOptions.statuses}
					onApply={(options) => handleMultiSelectFiltersApply('statuses', options)}
				/>
				{isFlexEnabled && isOnDemandEnabled && (
					<MultiSelectSearch
						showLongSelectionText
						className="select-filter-status-container"
						label="Shift route"
						options={routeOptions}
						onApply={(options) => handleMultiSelectFiltersApply('shiftRoutes', options)}
					/>
				)}
				{shouldShowUnitsFilter && (
					<MultiSelectSearch
						showLongSelectionText
						className="select-filter-status-container"
						label="Units"
						options={activeOptions.units}
						onApply={(options) => handleMultiSelectFiltersApply('units', options)}
						disabled={isUnitsFilterDisabled}
					/>
				)}
				<MultiSelectSearch
					showLongSelectionText
					className="select-filter-status-container"
					label="Features"
					options={featureOptions}
					onApply={(options) => handleMultiSelectFiltersApply('features', options)}
				/>
			</div>
			<ProfessionalSearch
				className="filter-item push-right"
				selectedCaregiver={selectedCaregiver}
				setSelectedCaregiver={handleCaregiverFilterSelection}
				isOpen={isCaregiverSelectOpen}
				setIsOpen={setIsCaregiverSelectOpen}
				removeSelectedCaregiver={handleRemoveCaregiver}
				emptyListPlaceholder="No enabled professionals found"
				placeholder="Search for professional"
				clearVariantButton="WARNING"
				textVariant="BOLD"
				type={globalScheduleType}
				searchURL={ENDPOINTS.SEARCH_ACTIVE_WORKER}
			/>
		</div>
	);
};

export default memo(GlobalOverviewFilters);
